<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Plans",
  setup() {
    // load all the plans data, then show routerview
  },
};
</script>
